import { render, staticRenderFns } from "./SubjectsView.vue?vue&type=template&id=3c143798&scoped=true"
import script from "./SubjectsView.vue?vue&type=script&lang=js"
export * from "./SubjectsView.vue?vue&type=script&lang=js"
import style0 from "./SubjectsView.vue?vue&type=style&index=0&id=3c143798&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c143798",
  null
  
)

export default component.exports